export const moduleType = {
  ORDER: 'today_order',
  SUCCESS: 'today_success',
  WAITLISTING: 'wait_listing',
  WAITORDER: 'wait_order',
  LISTEDPERFORMANCE: 'listed_performance',
}

export const localStorage = {
  SHOWBOND: 'showBond',
}